import React from 'react';
import { CardContainer } from '../../shared/components/card';
import { DataTable, DataColumn } from '../../shared/components/dataTable';
import { Button, EditButton } from '../../shared/components/button';
import AddIcon from '../../assets/images/svg/AddIcon';
import { nullFn } from '../../shared/utils';

type TableDataType = {
  id: string;
  name: string;
  email: string;
  tags: string[];
  date: string;
  status: string;
  edit: () => void;
};

export class TableDevelopmentPage extends React.Component {
  render(): JSX.Element {
    const rows: TableDataType[] = [
      {
        id: '1',
        name: 'Jill Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '12',
        name: 'Doug Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '123',
        name: 'John Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '1234',
        name: 'Bob Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '2',
        name: 'Marty Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '22',
        name: 'Doc Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '223',
        name: 'Annie Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '2234',
        name: 'Dave Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '3',
        name: 'Mickey Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '32',
        name: 'Charlie Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '323',
        name: 'Abe Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '3234',
        name: 'Millie Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '4',
        name: 'Sam Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '42',
        name: 'Jimmy Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '423',
        name: 'Johnny Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
      {
        id: '4234',
        name: 'Lil Smith',
        email: 'member@aivia.ca',
        tags: ['one', 'two'],
        date: '18-09-2020',
        status: 'Active',
        edit: () => alert('Edit Clicked'),
      },
    ];

    const cols: DataColumn<TableDataType>[] = [
      {
        selector: 'name',
        name: 'Name',
      },
      {
        selector: 'email',
        name: 'Email',
      },
      {
        selector: 'tags',
        name: 'Tags',
      },
      {
        selector: 'date',
        name: 'Date',
      },
      {
        selector: 'status',
        name: 'Status',
      },
      {
        selector: 'edit',
        name: 'Edit',
        button: true,
        width: '60px',
        cell: (row) => <EditButton onClick={row.edit} />,
      },
    ];

    return (
      <div className='min-h-screen w-full bg-gray-lightest'>
        <div className='mx-auto w-3/4 py-20'>
          <h1>Table Development</h1>
          <CardContainer stripPadding={true}>
            {/* Start Table Development Here */}
            <DataTable
              data={rows}
              actions={
                <Button
                  label='New User'
                  theme='SMALL_PRIMARY'
                  icon={<AddIcon />}
                  onClick={() => alert('clicky clicky')}
                />
              }
              filterActions={
                <div>
                  <h2>Something here</h2>
                </div>
              }
              columns={cols}
              title='Recent Posts'
              selectableRows={true}
              selectableRowsNoSelectAll={true}
              onSelectedRowsChange={nullFn}
              onChangePage={nullFn}
              pagination={true}
              paginationPerPage={6}
            />
            {/* End Table Development Here  */}
          </CardContainer>
        </div>
      </div>
    );
  }
}
